// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"7b18ff6c","584":"91151bad"}[chunkId] + ".chunk.js";
};